var render = function() {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c(
    "svg",
    {
      class: { "audio-lines-icon--animado": _vm.animado },
      attrs: {
        width: _vm.size,
        height: _vm.size,
        viewBox: "0 0 24 24",
        fill: "none",
        xmlns: "http://www.w3.org/2000/svg"
      }
    },
    [
      _c("rect", {
        staticClass: "audio-lines-icon__bar audio-lines-icon__bar--1",
        attrs: {
          x: "1.5",
          y: "7",
          width: "3",
          height: "10",
          rx: "1.5",
          fill: _vm.color
        }
      }),
      _c("rect", {
        staticClass: "audio-lines-icon__bar audio-lines-icon__bar--2",
        attrs: {
          x: "7.5",
          y: "3",
          width: "3",
          height: "18",
          rx: "1.5",
          fill: _vm.color
        }
      }),
      _c("rect", {
        staticClass: "audio-lines-icon__bar audio-lines-icon__bar--3",
        attrs: {
          x: "13.5",
          y: "5",
          width: "3",
          height: "14",
          rx: "1.5",
          fill: _vm.color
        }
      }),
      _c("rect", {
        staticClass: "audio-lines-icon__bar audio-lines-icon__bar--4",
        attrs: {
          x: "19.5",
          y: "8",
          width: "3",
          height: "8",
          rx: "1.5",
          fill: _vm.color
        }
      })
    ]
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }